
import angular from "angular";

import Assert from "tbAssert";
import EventType from "../models/EventType";
import TbAppConfigDataServiceModule from "../config/tb-app-config/TbAppConfigDataService";

const mHttpSvc = new WeakMap();
const mLogSvc = new WeakMap();
const mQSvc = new WeakMap();

const mTbServerBaseUrl = new WeakMap();

class AllEventTypesService {
    constructor($log, $http, $q, TbAppConfigDataService) {
        Assert.StrictAssert($log != null, "Assertion Failed: Missing log service dependency");
        Assert.StrictAssert($http != null, "Assertion Failed: Missing log service dependency");
        Assert.StrictAssert($q != null, "Assertion Failed: Missing log service dependency");
        Assert.StrictAssert(TbAppConfigDataService != null, "Assertion Failed: Missing TrackerBase Application Configuration Data Service Dependency");

        mLogSvc.set(this, $log);
        mHttpSvc.set(this, $http);
        mQSvc.set(this, $q);
        mTbServerBaseUrl.set(this, TbAppConfigDataService.tbServerBaseUrl);

        this.AllEventTypes = [];
    }

    toString() {
        return `All Events Service (${this.AllEventTypes.length}) events.`;
    }

    RetrieveAllEventTypesAsync() {
        return mHttpSvc.get(this)({
            method: "GET",
            url: mTbServerBaseUrl.get(this) + "/api/eventtypes"
        }).then((response) => {

            if (response != null) {
                let responseData = response.data;
                if (responseData["Items"] != null) {

                    this.AllEventTypes.length = 0;
                    responseData.Items.forEach((svrEvtType) => {
                        if (svrEvtType != null) {

                            let evtType = EventType.FromServerEventType(svrEvtType);
                            this.AllEventTypes.push(evtType);
                        }

                    });

                    return true;

                } else {
                    this.AllEventTypes.length = 0;
                    return mQSvc.get(this).reject("Invalid event types response data");
                }
            }
            else {
                this.AllEventTypes.length = 0;
                return mQSvc.get(this).reject("Invalid event types response");
            }

        }, (response) => {
            this.AllEventTypes.length = 0;
            mLogSvc.get(this).error("Event Types retrieval failed.");
            return mQSvc.get(this).reject(response);
        });
    }

    PreLoadEventTypesData() {
        return this.RetrieveAllEventTypesAsync();
        // REDUNDANT PASS-THROUGH.
        //     .then(function(status) {
        //     return status;
        // }, function(errorResponse) {
        //     return errorResponse;
        // })
    }
    
    GetEventTypes() {
        return this.AllEventTypes.map(function(et) {
            return EventType.Copy(et);
        });
    }
    
    GetEventTypesAsync() {
        let eventTypesDataPromise = null;
    
        if (this.AllEventTypes.length > 0) {
            eventTypesDataPromise = mQSvc.get(this).when(this.GetEventTypes());
        }
        else {
            eventTypesDataPromise = this.RetrieveAllEventTypesAsync().then(() => {
                return this.GetEventTypes();
            }, (errorResponse) => {
                return mQSvc.get(this).reject(errorResponse);
            });
        }
    
        return eventTypesDataPromise;
    }

    FromId(etId) {
        let eventTypeSearchResults =
            this.AllEventTypes.filter(function(element) {
                return (element["eventTypeId"] === etId);
            });
    
        if (eventTypeSearchResults.length === 1) {
            return eventTypeSearchResults[0];
        }
        else {
            return undefined;
        }
        
    }
    
    FromName(etName) {
        let eventTypeSearchResults =
            this.AllEventTypes.filter(function(element) {
                return (element["eventTypeName"] === etName);
            });

        if (eventTypeSearchResults.length === 1) {
            return eventTypeSearchResults[0];
        } else {
            return undefined;
        }
    }


}

AllEventTypesService.$inject = [ "$log", "$http", "$q", "TbAppConfigDataService" ];

export default angular
    .module("trackerbase-app.services.all-event-types-service",[
        TbAppConfigDataServiceModule
    ])
    .service("AllEventTypesService", AllEventTypesService)
    .name;



//////////////////
// WEBPACK FOOTER
// ./src/services/AllEventTypesService.js
// module id = 0dIE
// module chunks = 1